import { cn } from '~/shadcn/lib/utils'

export const StageLabel = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'flex max-w-fit flex-col items-center rounded bg-[#CCC] px-1 py-0.25 text-xs text-[#222] font-semibold uppercase leading-[18px]',
      className
    )}
    {...props}
  />
)
